import { About, Navbar, Hero, Projects, Footer, Contact } from './index'

function Home() {
    
  return (
    <>
        <Navbar />
        <Hero />
        <About />
        <Projects />
        <Contact />
        <Footer />
    </>
  )
}

export default Home